import { formatPercentage } from '@/helpers';
import { IAudienceSegment } from '@/interfaces';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const AudienceSegmentSelect: React.FC<{
  segments: IAudienceSegment[];
  selectedId: number;
  onChange: (id: number) => void;
}> = ({ segments, selectedId, onChange }) => (
  <FormControl variant="filled" size="small" sx={{ minWidth: 180 }}>
    <InputLabel id="view-select-label">Segment</InputLabel>
    <Select
      value={selectedId}
      onChange={(event) => onChange(event.target.value as number)}
      label="Segments"
    >
      {segments.map((segment, index) => (
        <MenuItem key={segment.id} value={segment.id}>
          {index === 0
            ? segment.name
            : `${segment.name} (${formatPercentage(
                segment.summary.audience_size.segment_percent
              )})`}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default AudienceSegmentSelect;
